import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-notification-toast',
    imports: [CommonModule, MatButtonModule, MatIconModule],
    template: `
    <div class="notification-toast">
      <div class="toast-content">
        <mat-icon class="toast-icon">{{ data.icon || 'notifications' }}</mat-icon>
        <div class="toast-text">
          <div class="toast-title">{{ data.title }}</div>
          <div class="toast-body">{{ data.body }}</div>
        </div>
      </div>
      <div class="toast-actions">
        <button mat-icon-button (click)="dismiss()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  `,
    styles: [`
    .notification-toast {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-width: 300px;
      padding: 12px;
    }

    .toast-content {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .toast-icon {
      margin-right: 12px;
      color: #2196F3;
    }

    .toast-text {
      flex: 1;
    }

    .toast-title {
      font-weight: 500;
      margin-bottom: 4px;
    }

    .toast-body {
      font-size: 14px;
      color: rgba(0,0,0,0.7);
    }
  `]
})
export class NotificationToastComponent implements OnInit {
  constructor(
    public snackBarRef: MatSnackBarRef<NotificationToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  ngOnInit() {
    // Auto dismiss after 5 seconds
    setTimeout(() => {
      this.dismiss();
    }, 5000);
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
